<template>
  <div class="jump-usercenter nav-bar-fixed">
    <van-nav-bar title="账户安全" left-arrow fixed @click-left="back" />
    <h5>基础信息</h5>
    <!--<van-field-->
    <!--label="登录邮箱"-->
    <!--value="123242523"-->
    <!--readonly-->
    <!--&gt;-->
    <!--<van-button slot="button" size="small" type="primary">修改</van-button>-->
    <!--</van-field>-->
    <van-field label="手机号码" :value="userinfo.mobile" readonly>
      <van-button slot="button" size="small" type="primary" @click="userMobile">修改</van-button>
    </van-field>
    <van-field label="邮箱" :value="userinfo.email" placeholder readonly>
      <!--<van-button slot="button" size="small" type="primary">修改</van-button>-->
    </van-field>
    <van-field label="可用积分" :value="userinfo.integral" readonly />
    <h5>修改密码</h5>
    <van-field required v-model="oldPassword" type="password" label="当前密码" placeholder="请输入6位当前密码" />
    <van-field required v-model="newPassword" type="password" label="新密码" placeholder="请输入6位当前密码" />
    <van-field
      required
      v-model="confirmPassword"
      type="password"
      label="确认新密码"
      placeholder="请输入6位当前密码"
    />
    <div class="usercenter-button">
      <van-button size="large" @click="updatePass">提 交</van-button>
    </div>
    <div class="usercenter-button">
      <van-button size="large" @click="loginOut">退出账号</van-button>
    </div>
  </div>
</template>
<script>
import {
  NavBar,
  Row,
  Col,
  Field,
  Button,
  Popup,
  Picker,
  Cell,
  CellGroup,
  RadioGroup,
  Radio,
  DatetimePicker
} from "vant";

export default {
  name: "usersafe",
  components: {
    [NavBar.name]: NavBar,
    [Row.name]: Row,
    [Col.name]: Col,
    [Field.name]: Field,
    [Button.name]: Button,
    [Popup.name]: Popup,
    [Picker.name]: Picker,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [DatetimePicker.name]: DatetimePicker
  },
  data() {
    return {
      oldPassword: "",
      newPassword: "",
      confirmPassword: "",
      userinfo: {}
    };
  },
  mounted: function() {
    this.getUserInfo();
  },
  methods: {
    back() {
      history.back();
    },
    userMobile() {
      this.$router.push({ path: "/user/usermobile" });
    },
    updatePass() {
      let that = this;
      that.$api.post(
        that.jumuc.userCenter.updatePass,
        {
          oldPassword: that.oldPassword,
          newPassword: that.newPassword,
          confirmPassword: that.confirmPassword
        },
        successRes => {
          that.$toast(successRes.msg);
          if (successRes.success) {
            that.$router.push({ path: "/usercent" });
          }
        }
      );
    },
    getUserInfo() {
      let that = this;
      that.$api.get(that.jumuc.userCenter.getUserInfo, null, successRes => {
        that.userinfo = successRes.data.user;
      });
    },
    loginOut() {
        let that=this;
      localStorage.setItem("beforeUrl", 1);
      // var ckv = localStorage.getItem('ckeckVal');
      if (localStorage.getItem("iosapp")) {
        window.webkit.messageHandlers.loginOut.postMessage("");
        localStorage.setItem("iosapp", false);
      }
      that.$api.post(
        that.jumuc.user.logOut,
        {
          token: localStorage.getItem("token")
        },
        successRes => {
          if (successRes.success) {
            localStorage.removeItem("token"); //用户id
            location.href = "#/login";
          }
        }
      );
    }

    // ckv == true
    //if (!ckv) {
    /*localStorage.removeItem("name") //用户名
                    localStorage.removeItem("username") //用户名
                    localStorage.removeItem("mobile") //手机号
                    localStorage.removeItem("userId") //用户id*/
    //     localStorage.removeItem("token") //用户id
    //     location.href = "#/login"
    // }else{
    //     localStorage.removeItem("token") //用户id
    //     location.href = "#/login"
    // }
  }
};
</script>
<style lang="less">
@bule-thame: #3c6eeb;
.jump-usercenter {
  padding-top: 50px;
  h5 {
    color: @bule-thame;
    font-size: 16px;
    padding: 10px 15px;
  }
  button {
    background-color: @bule-thame;
    border-color: @bule-thame;
  }
  .usercenter-button {
    padding: 0 15px;
    button {
      background-color: @bule-thame;
      color: white;
      font-weight: 700;
      border-radius: 5px;
      margin: 25px 0 10px;
    }
  }

  .van-radio-group {
    .van-cell__title {
      max-width: 90px;
    }
    .van-cell__value {
      text-align: left;
      .van-radio {
        display: inline-block;
        margin-right: 15px;
      }
    }
  }
}
</style>

